// extracted by mini-css-extract-plugin
export default {"cls1":"styles-cls1__f57bf224b4a376fd7b3e","cls2":"styles-cls2__e834a7170c9568ac92d7 styles-cls1__f57bf224b4a376fd7b3e"};